module.exports = __webpack_public_path__ + "static/skihire--map-9b00aa63a8f12fd0edff5b697a9b9772.png";